'use strict';

import { flow, observable, configure, makeObservable } from "mobx";
configure({enforceActions: 'always'});

import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import {States} from '@uw-it-sis/lib-react/lib/AppConstants';

/**
 * Store for retrieving notices for the user
 */
class NoticesStore {
    state = States.initial;

    notices = [];

    mount = flow(function* () {
        this.state = States.pending;

        // Ignore requests for notices if user is not a student
        // If an adviser is advising a student, appStore.isStudent() will still return true
        if ( appStore.isStudent() ) {
            try {
                this.notices = yield appStore.getHttpClient().doGet('api/notice/notices', 'getNotices');
                if (appStore.isDevMode()) {
                    console.log("NoticesStore: Data load complete.");
                }
                this.state = States.done;
            } catch(error) {
                //appStore.getExceptionUtils().handleException(error);
                this.state = States.error;
            }
        } else {
            this.state = States.done;
        }
    }.bind(this));

    constructor() {
        makeObservable(this, {
            state: observable,
            notices: observable
        });
    }

    /**
     * Returns an array of notices which can be filtered by passing a category name. The absence
     * of a category returns all notices.
     *
     * @param category is a string that corresponds to the MyPlan category name for notices,
     *        passing a category will only show notices that match the MyPlan category.
     * @param quarter is a string that corresponds with a notice attribute for further filtering.
     *        Passing a quarter will only show notices that also match the quarter
     * @returns array of notice messages
     */
    getNotices(category, quarter) {
        return this.notices.filter((notice) => {
            // if category is specified, match the myplan category; else show all categories
            let matchCategory = category && notice.hasOwnProperty("myplanCategory") ? category.toUpperCase() === notice.myplanCategory.toUpperCase() : true;
            // if quarter is specified, match the quarter attribute; else show all quarters
            let matchQuarter = quarter && notice.attributes?.hasOwnProperty("Quarter") ? quarter.toUpperCase() === notice.attributes.Quarter.toUpperCase() : true;

            return matchCategory && matchQuarter;
        });
    }

    /**
     * Returns the length of notices which can be filtered by passing a category name. The absence
     * of a category returns the length of all notices.
     * @param category - a string that corresponds to the MyPlan category name for notices,
     *        passing a category will only count notices that match the MyPlan category.
     * @return {number} length of notices
     */
    getNoticesCount(category) {
        let count;
        if ( category ) {
            count = this.getNotices(category).length;
        } else {
            count = this.notices.length;
        }

        return count;
    }

    /**
     * Returns boolean if the store's array of notices (_notices) contains items with MyPlan category type that is within the array of categories provided.
     * @param categories - array of categories to check for within the store's array of notices.
     * @returns {boolean}
     */
    hasMessaging(categories) {
        if ( categories ) {
            for (let i = 0; i < this.notices.length; i++) {
                if ( categories.indexOf(this.notices[i].myplanCategory) >= 0 ) {
                    return true;
                }
            }
        }

        return false;
    }
}

export default new NoticesStore();
